import currencies from "./currencies";
import dates from "./dates";

export function getLang() {
    if (!window.lang) {
        // determine lang from query parameter for dev environment
        const match = window.location.search.match(/lang=([^&]+)/);
        return match ? match[1] : "de-DE";
    } else {
        return window.lang;
    }
}

async function getFallbackMessages(lang: string) {
    switch (lang) {
        case "bg-BG":
            return await import("./bg-BG.json");
        case "cs-CZ":
            return await import("./cs-CZ.json");
        case "de-DE":
            return await import("./de-DE.json");
        case "en-PK":
            return await import("./en-PK.json");
        case "es-ES":
            return await import("./es-ES.json");
        case "fr-FR":
            return await import("./fr-FR.json");
        case "hr-HR":
            return await import("./hr-HR.json");
        case "hu-HU":
            return await import("./hu-HU.json");
        case "it-IT":
            return await import("./it-IT.json");
        case "nl-NL":
            return await import("./nl-NL.json");
        case "pl-PL":
            return await import("./pl-PL.json");
        case "pt-PT":
            return await import("./pt-PT.json");
        case "ro-MD":
            return await import("./ro-MD.json");
        case "ro-RO":
            return await import("./ro-RO.json");
        case "ru-KZ":
            return await import("./ru-KZ.json");
        case "ru-RU":
            return await import("./ru-RU.json");
        case "sk-SK":
            return await import("./sk-SK.json");
        case "sr-RS":
            return await import("./sr-RS.json");
        case "tr-TR":
            return await import("./tr-TR.json");
        case "uk-UA":
            return await import("./uk-UA.json");
        default:
            return await import("./en-US.json");
    }
}

async function getCorrectMessagesOrDefault(lang: string) {
    const langUnderscore: string = lang.replace("-", "_");
    const correctMessages =
        //@ts-ignore
        typeof window !== "undefined" ? window["translations_EXPLORE_" + langUnderscore] : undefined;
    if (correctMessages) {
        return correctMessages;
    }
    return getFallbackMessages(lang);
}

const lang = getLang();
//@ts-ignore
const messages = await getCorrectMessagesOrDefault(lang);

export const getMessages = () => messages;

export const getFormats = () => ({ ...currencies, ...dates });

declare global {
    interface Window {
        lang: string;
    }
}
